'use client';

import { useEqualHeight } from '@/hooks/useEqualHeight';
import { BlockLocationProps } from '@/types/blocks';
import type { DirectusFieldAspectRatio } from '@/types/directus';
import Link from 'next/link';
import { Button } from '../ui/Button';
import { Tile } from '../ui/Tile';

const ASPECT_RATIO_DEFAULT: DirectusFieldAspectRatio = 'square';

export function Location(props: BlockLocationProps) {
  const {
    heading,
    subheading,
    image,
    aspectRatio = ASPECT_RATIO_DEFAULT,
    link,
    ...rest
  } = props;

  const headingRef = useEqualHeight<HTMLHeadingElement>('heading');

  return (
    <Tile
      image={image}
      className='flex h-full flex-col justify-between p-7 md:p-15'
      aspectRatio={aspectRatio}
      data-test='location'
      data-equalize-root
      {...rest}
    >
      <div data-header className='space-y-3'>
        <h1
          ref={headingRef}
          className='text-sh-white sh-heading-3 line-clamp-3 font-sans'
        >
          {heading}
        </h1>
        <p className='text-sh-white sh-body font-sans'>{subheading}</p>
      </div>
      <div data-footer>
        <Button variant='light' asChild>
          {link && <Link href={link}>View Location</Link>}
        </Button>
      </div>
    </Tile>
  );
}
